import React from 'react';

class NoAccessAllowed extends React.Component {
  render() {
    return (
      <div>
        You are not subscribed to Tickmark Reporting Tool. Contact your admin.
      </div>
    );
  }
}

export default NoAccessAllowed;
